import { useSyncExternalStore } from "react";

interface PendingDrawerVisibilityState {
    isOpen: boolean;
    timeoutId: number;
}

const DRAWER_VISIBILITY_TTL_MS = 5000;

const pendingDrawerVisibility = new Map<string, PendingDrawerVisibilityState>();
const listeners = new Set<() => void>();

const notifyListeners = () => {
    listeners.forEach((listener) => listener());
};

const clearPendingDrawerVisibilityInternal = (drawerId: string) => {
    const existingState = pendingDrawerVisibility.get(drawerId);

    if (existingState) {
        window.clearTimeout(existingState.timeoutId);
        pendingDrawerVisibility.delete(drawerId);
        notifyListeners();
    }
};

export const setPendingDrawerVisibility = (drawerId: string, isOpen: boolean) => {
    clearPendingDrawerVisibilityInternal(drawerId);

    const timeoutId = window.setTimeout(() => {
        clearPendingDrawerVisibilityInternal(drawerId);
    }, DRAWER_VISIBILITY_TTL_MS);

    pendingDrawerVisibility.set(drawerId, {
        isOpen,
        timeoutId,
    });

    notifyListeners();
};

export const clearPendingDrawerVisibility = (drawerId: string) => {
    clearPendingDrawerVisibilityInternal(drawerId);
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
};

const getSnapshot = (drawerId: string) => pendingDrawerVisibility.get(drawerId)?.isOpen;

export const usePendingDrawerVisibility = (drawerId: string) => {
    return useSyncExternalStore(
        subscribe,
        () => getSnapshot(drawerId),
        () => undefined
    );
};
